// extracted by mini-css-extract-plugin
export var title = "audit-module--title--tnYQ-";
export var logoContainer = "audit-module--logoContainer--wrJYM";